
import state from './moduleTagManagementState'
import mutations from './moduleTagManagementMutations'
import actions from './moduleTagManagementActions'
import getters from './moduleTagManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

